import { isAnyOf, Middleware } from '@reduxjs/toolkit'
import { ViewTimelineActions } from './slices/view-timeline-slice'
import { RootState } from './store'

export const LOCAL_STORAGE_KEY = 'timeline-planner-data-v1'

export const localStorageMiddleware: Middleware<
    {}, // Most middleware do not modify the dispatch return value
    RootState
> = storeApi => next => action => {

    // Run the action first and do the saving on the way back up, this
    // ensures state is updated before we save
    next(action)

    // TODO: This is super duper dangerous, if we forget to hook up
    // new actions here we're gonna lose data
    const matcher = isAnyOf(
        ViewTimelineActions.saveFightChanges,
        ViewTimelineActions.createFight,
        ViewTimelineActions.cloneFight,
        ViewTimelineActions.setFightName,
        ViewTimelineActions.deleteFight
    )

    if (matcher(action)) {
        const { viewTimeline } = storeApi.getState()

        const data = JSON.stringify({
            viewTimeline: {
                storedFights: viewTimeline.storedFights,
            },
        } as Partial<RootState>)

        localStorage.setItem(LOCAL_STORAGE_KEY, data)
    }

}
